import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../../crbt/crbtuicss';

export interface DedicateFlashMessageCSSStyle extends CRBTUICSSStyle
{
    getTitleCSSStyle(): object;
    getBackCSSStyle(): object;
}

export class DedicateFlashMessageCSSStyleImpl extends CRBTUICSSStyleImpl implements DedicateFlashMessageCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '100%', 
            width: '100%',
            fontFamily: this.getContext().getResources().getFontFamily(),
            // display: "flex",
        };
    }

    getBackCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "right",
            justifyContent: 'flex-end',
            // height: "30px",
            cursor: "pointer",
            fontWeight: "bold",
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: "16px",
            color: this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "30px",
            // marginTop: '52px',  
            // marginBottom: '38px',
            // marginLeft: '0px',
        };
    }

    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            height: "30px",
            fontWeight: 800,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: this.getResources().getFont(Fonts.h11),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px",
            // paddingTop: '70px',  
            // marginBottom: '50px',
            // marginLeft: '0px',
        };
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicateflashmessagecss.tsx